var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 77,
    viewBox: "0 0 238 77",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 232,
    height: 71,
    rx: 12,
    fill: "#ffffff",
    stroke: "#009444",
    strokeWidth: 2.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 119,
    y: 45,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 19,
    fontWeight: 400,
    fill: "#009444"
  }, "Animal Rights")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint1);
export default __webpack_public_path__ + "static/media/point1.c9902d846fcaccdc73591633c13f3996.svg";
export { ForwardRef as ReactComponent };